import React, { FunctionComponent } from 'react';

import {
  AppBar as MuiAppBar,
  Toolbar,
  useMediaQuery,
  Theme,
  Slide,
  AppBarProps as MuiAppBarProps,
  useScrollTrigger,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(
  theme => ({
    toolbar: {
      height:80,
      paddingRight: 40,
    },
    menuButton: {
      marginLeft: '0.5em',
      marginRight: '0.5em',
    },
    menuButtonIconClosed: {
      transition: theme.transitions.create(['transform'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      transform: 'rotate(0deg)',
    },
    menuButtonIconOpen: {
      transition: theme.transitions.create(['transform'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      transform: 'rotate(180deg)',
    },
    title: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  }),
  { name: 'OrbitAppBar' }
);

function HideOnScroll(props: { children: React.ReactElement }) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export type AppBarProps = Omit<MuiAppBarProps, 'title' | 'classes'>;

const AppBar: FunctionComponent<AppBarProps> = (props) => {
  const {
    className,
    color = 'secondary',
    ...rest
  } = props;
  const classes = useStyles(props);
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <HideOnScroll>
      <MuiAppBar className={className} color={color} elevation={0} {...rest}>
        <Toolbar
          disableGutters
          variant={isXSmall ? 'regular' : 'dense'}
          className={classes.toolbar}
        >
          {props.children}
        </Toolbar>
      </MuiAppBar>
    </HideOnScroll>
  );
};

export default AppBar;
